import React, { useMemo } from "react";
import { Body2, InfoIcon, WarningTriangleIcon } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";

const SubscriptionInfoBlock = ({ color, iconType, content, blockTitle }) => {
  const iconColor = useMemo(() => {
    switch (color) {
      case "red":
        return "#ED6161";
      case "green":
        return "#64CD93";
      case "orange":
        return "#FBBB75";
    }
  }, [color]);

  const icon = useMemo(() => {
    switch (iconType) {
      case "warning":
        return (
          <WarningTriangleIcon
            fill={iconColor}
            className="tw-p-0 tw-mr-5 tw-shrink-0"
          />
        );
      case "info":
        return (
          <InfoIcon
            fill={iconColor}
            className="tw-p-0 tw-mr-5 tw-shrink-0"
          />
        );
    }
  }, [iconColor, iconType]);

  const titleColor = useMemo(() => {
    switch (color) {
      case "red":
        return "alert";
      case "green":
        return "success";
      case "orange":
        return "warning";
    }
  }, [color]);

  return (
    <div
      className={classnames("tw-border-solid tw-border-2 tw-rounded-lg", {
        "tw-border-red-500": color === "red",
        "tw-border-green-500": color === "green",
        "tw-border-yellow-500": color === "orange",
      })}
    >
      <div className="tw-flex tw-p-6">
        {icon}
        <div>
          <Body2
            color={titleColor}
            weight="bold"
            className="tw-mb-1"
          >
            {blockTitle}
          </Body2>
          {content}
        </div>
      </div>
    </div>
  );
};

SubscriptionInfoBlock.propTypes = {
  color: PropTypes.string,
  iconType: PropTypes.string,
  content: PropTypes.element,
  blockTitle: PropTypes.string,
};

SubscriptionInfoBlock.displayName = `SubscriptionInfoBlock`;

export default SubscriptionInfoBlock;
